import { Event } from "./Event";
/**
 * Item Selected Event
 */
export class ItemSelectedEvent extends Event {
    /**
     * Constructor
     * @param element element
     * @param data data
     * @param index index (optional)
     */
    constructor(element, data, index) {
        super(element, data);
        this.index = index;
    }
    /**
     * Gets index
     */
    getIndex() {
        return this.index;
    }
}
//# sourceMappingURL=ItemSelectedEvent.js.map